import $ from 'jquery';

let currentMunicipe = {};

export default {
	getCurrent(data = {}) {
		return $.ajax(`${Config.BASE_URL}/municipe`, { data }).then(response => currentMunicipe = response);
	},

	checkCEP(params = {}) {
		return $.ajax(`${Config.BASE_URL}/municipe/consultaCep`, params);
	},

	checkCPF(params = {}) {
		if (currentMunicipe) {
			params.data.idMunicipe = currentMunicipe.id;
		}

		return $.ajax(`${Config.BASE_URL}/municipe/consultaCpf`, params);
	},

	logout() {
		return $.ajax(`${Config.BASE_URL}/permisys`, { method: 'DELETE' }).then(() => {
			currentMunicipe = {};
		});
	}
};


// WEBPACK FOOTER //
// ./application/models/municipe.js